import { Route } from "@angular/router";

export const costosRoutes: Route[] = [
  { path: 'list', loadComponent: () => import('./pages/list/list.component').then(c => c.ListComponent) },
]